import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import L from 'leaflet';
import { Map as LeafletMap, LayersControl, TileLayer, ZoomControl, GeoJSON, LayerGroup, ScaleControl } from 'react-leaflet';
const { Overlay, BaseLayer } = LayersControl;
import 'leaflet/dist/leaflet.css';
import 'leaflet-wfst';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import Row from '../../common/Row';
import Col from '../../common/Col';
import Button from '../../common/Button';
import generateGuid from "../../../util/guid";

import MapHelper from "./MapHelper";
import MapComponentHelper from "./MapComponentHelper";

import Markers from './Markers';
import Legende from './Legende';
import Manual from './Manual';
import MapLayersControl from './MapLayersControl';
import MapLoader from './MapLoader';
import Fieldset from "../Fieldset";
import * as LeafletMapConfig from "./LeafletMapConfig";

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingCounter: 0,
            failedCalls: 0,
            center: ['51.0132', '4.3554'],  //centre of vlaanderen
            lockBounds: false,
            editingMarkers: false,
            geoJsonLayers: [],
            markers: [],
            isEditingRoute: false,
            isLoading: false,
            editingLayerLeafletId: null,
            hideMap: false,
            legendeHovered: false,
            manualHovered: false
            // editingPolygon: false,
            // creatingPolygon: false,
            // editingPolygonFeatureId: null,
            // editingPolygonNaam: '',
            // editingPolygonLatLngs: '',
            // polygonenOnTheMap: [],
            // showPolygonDeleteConfirm: false
        };

        this.editControl = null;
        this.map = null;

        this.mapHelper = new MapHelper(this);
        this.componentHelper = new MapComponentHelper(this);

        this.loadMapConfig = this.loadMapConfig.bind(this);
        this.onMoveEnd = this.onMoveEnd.bind(this);

        this.onMarkerDragEnd = this.onMarkerDragEnd.bind(this);
        this.onLegendeHover = this.onLegendeHover.bind(this);
        this.onLegendeUnhover = this.onLegendeUnhover.bind(this);
        this.onManualHover = this.onManualHover.bind(this);
        this.onManualUnhover = this.onManualUnhover.bind(this);
    }

    componentDidMount() {
        if (this.map && this.map.leafletElement)
            this.loadMapConfig();

        //     this.setState({ editingPolygonLeafletId: e.layer._leaflet_id });
        // });
        this.setState({ hideMap: !this.props.showEmptyMap && !(this.props.children && this.props.children.length) && !(this.props.markers && this.props.markers.length) });
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.children && this.props.children.length || this.props.markers && this.props.markers.length) && prevState.hideMap === true)
            this.setState({ hideMap: false });
        else if (!this.props.showEmptyMap && !(this.props.children && this.props.children.length) && !(this.props.markers && this.props.markers.length) && prevState.hideMap === false && !this.state.isEditingRoute)
            this.setState({ hideMap: true });

        if (!this.state.hideMap && prevState.hideMap == true & this.map && this.map.leafletElement)
            this.loadMapConfig();

        if (this.props.customBounds != prevProps.customBounds)
            this.setState({ lockBounds: false }, () => this.setState({ lockBounds: true }));
    }

    loadMapConfig() {
        this.setState({ geoJsonLayers: this.props.geoJsonLayers }, () => {
            this.mapHelper.loadLayers();

            setTimeout(() => {
                this.mapHelper.loadLayers();
            }, 3000);
        });

        // this.setState({ geoJsonLayers: this.props.geoJsonLayers });
        //map configuration and base layer
        L.control.attribution({ position: 'bottomleft' }).addTo(this.map.leafletElement);
        L.tileLayer(this.props.baseLayerUrl,
            {
                id: 'MapID',
                attribution: this.props.baseLayerAttribution,
                maxNativeZoom: 20
            }).addTo(this.map.leafletElement);

        this.map.leafletElement.pm.setLang('nl');

        this.map.leafletElement.on('pm:create', (e) => {
            // if (this.state.creatingPolygon)
            this.map.leafletElement.pm.setGlobalOptions({ snappable: false });
            e.layer.pm.toggleEdit(LeafletMapConfig.DrawOptionsRed);
            e.layer.setStyle({ color: 'red' });

            this.setState({ editingLayerLeafletId: e.layer._leaflet_id });
        });
    }

    onMoveEnd(e) { this.componentHelper.onMoveEnd(e); }

    // onPolygonDrawStart = (e) => this.componentHelper.onPolygonDrawStart(e);
    // onPolygonEditStop = (e) => this.componentHelper.onPolygonEditStop(e);
    // onPolygonDrawStop = (e) => this.componentHelper.onPolygonDrawStop(e);
    // onPolygonEdited = (e) => this.componentHelper.onPolygonEdited(e);
    // onPolygonCreated = (e) => this.componentHelper.onPolygonCreated(e);
    // onClickDeletePolygon = () => this.setState({ showPolygonDeleteConfirm: true });
    // onPolygonDeleteClick = (confirmed) => this.componentHelper.onPolygonDeleteClick(confirmed);

    onMarkerDragEnd(e, id) { this.props.onMarkerDragEnd(e, id); }
    // onMarkerSave = () => this.componentHelper.onMarkerSave();
    // onMarkerCancel = () => this.componentHelper.onMarkerCancel();

    onLegendeHover() { this.setState({ legendeHovered: true }); }
    onLegendeUnhover() { this.setState({ legendeHovered: false }); }

    onManualHover() { this.setState({ manualHovered: true }); }
    onManualUnhover() { this.setState({ manualHovered: false }); }

    render() {
        const props = this.props;
        const state = this.state;
        const { center, lockBounds, legendeHovered, manualHovered, geoJsonLayers, loadingCounter, isEditingRoute, hideMap, editingLayerLeafletId } = state;
        const { markers, geoToolboxUrl, urlLayers, zoom, mapName, children, customBounds, customCenter, legendeCustomRows, routeEditable, isLoading, editButtonDisabled, hideLegende } = props;

        const hasRoute = !!(children && children.length);
        const mapStyle = hideMap ? { width: '100%', height: '600px', display: "none" } : { width: '100%', height: '600px' };

        const markersComponent = markers && markers.length ? <Markers
            markersToShow={markers}
            draggable={!(loadingCounter > 0)}
            onDragEnd={this.onMarkerDragEnd}
        /> : null;

        const hasOnlyOneMarker = markers.length === 1;
        const bounds = lockBounds ? null : markers.length === 0 || hasOnlyOneMarker ? customBounds && customBounds.length ? customBounds : hasOnlyOneMarker ? null : null : markers.map(m => [m.lat, m.long]);
        const zoomLevel = zoom ? zoom : markers.length === 0 ? (hasOnlyOneMarker ? zoom ? zoom : 18 : 13) : 13;
        const mapCenter = customCenter ? customCenter : state.center;

        const manualButtonStyle = {
            zIndex: '1000',
            position: 'absolute',
            top: '10px',
            right: '132px',
            paddingLeft: '10px',
            paddingRight: '10px'
        };

        const legendeButtonStyle = {
            zIndex: '1000',
            position: 'absolute',
            top: '10px',
            right: '10px'
        };

        return (<Fragment>
            {/* <Row>
                <Col size={3}>
                    <Button small text="" children={<Fragment><i key="" className="fa fa-map-signs" /> Legende</Fragment>} onMouseOver={this.onLegendeHover} onMouseOut={this.onLegendeUnhover} />
                </Col>
            </Row> */}
            <Row>
                <LeafletMap id={mapName} ref={(ref) => { this.map = ref; }}
                    center={mapCenter}
                    zoom={zoomLevel}
                    style={mapStyle}
                    minZoom={8}
                    zoomControl={false}
                    bounds={bounds}
                    boundsOptions={{ padding: [0, 0] }}
                    onmoveend={(e) => this.onMoveEnd(e)}
                    attributionControl={false}
                >
                    {loadingCounter > 0 || isLoading ? <MapLoader /> : ''}

                    {isEditingRoute ?
                        <Fragment>
                            <Button small color="#000" style={manualButtonStyle} className="leaflet-control-layers leaflet-control" text="" children={<div style={{ "color": '#000' }}><i key="" className="fa fa-book" /></div>} onMouseOver={this.onManualHover} />
                            {manualHovered ? <Manual onMouseOut={this.onManualUnhover} /> : null}
                        </Fragment>
                        : null}

                    {hideLegende ? null :
                        <Fragment>
                            <Button small color="#000" style={legendeButtonStyle} className="leaflet-control-layers leaflet-control" text="" children={<div style={{ "color": '#000' }}><i key="" className="fa fa-map-signs" /> Legende</div>} onMouseOver={this.onLegendeHover} />
                            {legendeHovered ? <Legende onMouseOut={this.onLegendeUnhover} customRows={legendeCustomRows} /> : null}
                        </Fragment>
                    }
                    <ScaleControl metric updateWhenIdle imperial={false} position="bottomright" />
                    <ZoomControl position="bottomright" />
                    <MapLayersControl
                        geoToolboxUrl={geoToolboxUrl}
                        urlLayers={urlLayers}
                        geoJsonLayers={geoJsonLayers}
                    />
                    {markersComponent}
                    {children}
                </LeafletMap>
            </Row>
            {
                routeEditable ?
                    (isEditingRoute ?
                        <Fieldset>
                            <Row>
                                <Button
                                    text={"Annuleer"}
                                    onClick={hasRoute ? this.mapHelper.onEditFeatureCancel : this.mapHelper.onDrawFeatureCancel} />
                                <Button
                                    text={"Bevestig getekende route "}
                                    onClick={hasRoute ? this.mapHelper.onEditFeatureStop : this.mapHelper.onDrawFeatureStop}
                                    disabled={!editingLayerLeafletId} />
                            </Row>
                        </Fieldset > :
                        hasRoute ?
                            <Fieldset>
                                <Row>
                                    <p className="o-col-9">&nbsp;</p>
                                    <Button
                                        text={"Wijzig route op kaart"}
                                        onClick={this.mapHelper.onEditFeatureStart}
                                        disabled={editButtonDisabled}
                                        size={3}
                                        style={{ float: 'right' }} />
                                </Row>
                            </Fieldset> :
                            <Fieldset>
                                <Row>
                                    <Col size={9}>
                                        Heb je nog geen GPX bestand van je route dan kan je deze hier uittekenen.
                                    </Col>
                                    <Button
                                        text={"Teken route op kaart"}
                                        onClick={this.mapHelper.onDrawFeatureStart}
                                        disabled={editButtonDisabled}
                                        size={3}
                                        style={{ float: 'right' }} />
                                </Row>
                            </Fieldset>
                    )
                    : null
            }
        </Fragment >);
    }
}

Map.propTypes = {
    geoToolboxUrl: PropTypes.string.isRequired,
    maxMapFeaturesToLoad: PropTypes.string.isRequired,
    baseLayerUrl: PropTypes.string.isRequired,
    baseLayerAttribution: PropTypes.string,
    mapName: PropTypes.string.isRequired,
    urlLayers: PropTypes.array,
    geoJsonLayers: PropTypes.array,
    markers: PropTypes.array,
    children: PropTypes.object,
    center: PropTypes.array,
    onMarkerDragEnd: PropTypes.func,
    legendeCustomRows: PropTypes.array,
    routeEditable: PropTypes.bool,
    routeFeatureName: PropTypes.string,
    handleUpdatefeature: PropTypes.func,
    handleStartDrawingRoute: PropTypes.func,
    handleCreatefeature: PropTypes.func,
    handleCancelRouteEdit: PropTypes.func,
    handleCancelRouteCreate: PropTypes.func,
    isLoading: PropTypes.bool,
    handleEditFeature: PropTypes.func,
    hideMap: PropTypes.bool,
    customBounds: PropTypes.array,
    showEmptyMap: PropTypes.bool,
    zoom: PropTypes.number,
    customCenter: PropTypes.bool,
    editButtonDisabled: PropTypes.bool,
    hideLegende: PropTypes.bool
};

Map.defaultProps = {
    urlLayers: [{
        name: 'Luchtfoto',
        attribution: "Orthofotomozaïek © Agentschap Informatie Vlaanderen",
        url: 'gwc/service/tms/1.0.0/geospakki:background/{z}/{x}/{y}.png',
        key: generateGuid(),
        tms: true,
        crs: 'EPSG:900913'
    }],
    geoJsonLayers: [],
    markers: [],
    baseLayerAttribution: '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
};

export default Map;
